import { useMemo } from 'react';
import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';
import type { Intermediary } from 'v2/pages/IntermediarySales/types';

export interface IntermediaryFilters {
  quarter?: string | null;
  market?: string | null;
  type?: string | null;
}

export const useIntermediarySales = (filters: IntermediaryFilters = {}) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/v2/intermediary/',
    {
      params: {
        query: {
          _quarter: filters.quarter ?? undefined,
          _market: filters.market ?? undefined,
          _type: filters.type ?? undefined
        }
      }
    }
  );

  const intermediaries: Intermediary[] = useMemo(() => {
    if (!data) return [];
    return ((data as any).intermediaries || []).map((i: any) => ({
      id: i.id,
      name: i.name,
      subtitle: i.subtitle,
      type: i.type,
      flagCode: i.flag_code,
      markets: i.markets,
      onTradeClients: i.on_trade_clients,
      bottlesSold: i.bottles_sold,
      yoyPercent: i.yoy_percent,
      performanceGrade: i.performance_grade,
      performancePercent: i.performance_percent
    }));
  }, [data]);

  return {
    isLoading,
    intermediaries,
    refetch
  };
};
